import * as React from 'react';
import OrderRow from './OrderRow';
import { NAVOrder, Order } from '../models/interfaces';

interface OrderHistoryListProps {
  orders: Array<NAVOrder>;
}

const OrderHistoryList = (props: OrderHistoryListProps) =>  {
  const { orders } = props;
  return(
    <div className="order-list condensed">
      <div className="table table--customer">
        <div className="row row--header">
          <div className="cell">Tilaus pvm</div>
          <div className="cell">Asiakkaan nimi</div>
          <div className="cell">Osoite</div>
          <div className="cell">Postinumero</div>
          <div className="cell">Kaupunki</div>
        </div>
        {
          orders
          .sort( (a, b) => a.OrderDate < b.OrderDate ? 1 : a.OrderDate > b.OrderDate ? -1 : 0)
          .map(order => <OrderRow order={order} key={order.OrderId} />)
        }
      </div>
    </div>
  );
};

export default OrderHistoryList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/OrderHistoryList.tsx